<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Trace Route</h4>
          <el-form :model="traceRouteForm" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :rules="checktraceRouteForm"
            ref="traceRouteForm"
            >
            <el-form-item label="Interface Selection:">
                <el-select v-model="traceRouteForm.wanIndex" @change="wanChange" placeholder="Please select" style="width: 100%">
                    <el-option label="br0" value="br0"></el-option>
                    <el-option v-for="item in netWanNamelsit" :key="item.index" :label="item.wanName" :value="item.index"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="Protocol Type:" prop="type">
                <el-select v-model="traceRouteForm.protocol" :disabled="protocolDisable" placeholder="Please select" style="width: 100%">
                    <el-option label="IPv4" value="4"></el-option>
                    <el-option label="IPv6" value="6"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="Target Address:" prop="address">
                <el-input v-model="traceRouteForm.address"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="sendData">Start</el-button>
            </el-form-item>
        </el-form>
     
       <div class="panel panel-default" style="margin: 30px 2.5%;"  v-show="traceRouteResults !== ''">
            <div class="panel-heading">
                Trace Route Test Results 
            </div>
            <div class="textb" v-html="traceRouteResults"></div>
        </div>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            protocolDisable:false,
            wanList:[],
            traceRouteForm:{
                wanIndex:'br0', // 0 => br0
                protocol:'4',
                address:''
            },
            checktraceRouteForm:{
                address:[{
                    validator: (rule, value, callback) => {
                        const protocol = this.traceRouteForm.protocol == "4" ? 4 : 6
                        const egText = this.traceRouteForm.protocol == "4" ? '192.168.1.100' : '1200::100'
                        if (!validator.isIP(value, protocol) && !validator.isFQDN(value)) {
                            callback(new Error(`Target Address Error!e.g. ${egText}`));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }],
            },
            traceRouteResults:''
        }
    },
    created(){
        this.getData()
    },
    computed: {
        netWanNamelsit() {
            let name = []
            this.wanList.forEach(e =>{
                if(e.mode === '0' && 
                ( e.serviceType === '0' || e.serviceType === '1' || e.serviceType === '6' || e.serviceType === '7') )
                {
                    name.push({wanName:e.wanName,index:e.index})
                }
            })
            return name
        }
    },
    methods: {
        getData() {
            this.loading = true
            axios
            .post("/boafrm/fhWANService",{CmdType:"GET_WAN"})
            .then((response)=>{
                this.loading = false                
                if(response.data.ret === 0)
                {
                    this.wanList = response.data.wanLists
                }
                else
                {
                    this.$message.error(`GET data failed! Error:${response.data.errorMsg}`)
                }
            })
        },
        setData() {
            this.loading = true
            axios
            .post("/boafrm/setformTracert",{
                wanifac: this.traceRouteForm.wanIndex,
                protocolType: this.traceRouteForm.protocol,
                target_addr: this.traceRouteForm.address
            })
            .then((response)=>{
                this.loading = false                
                if(response.data.ret === '0')
                {
                    this.traceRouteResults = response.data.traceRouteResults
                }
                else
                {
                    this.$message.error(`Trace Route test failed! Error:${response.data.errorMsg}`)
                }
            })
        },
        wanChange(val){
            this.protocolDisable = false
            if(this.wanList[val - 1] && this.wanList[val - 1].protocolType === '1')
            {
                this.protocolDisable = true
                this.traceRouteForm.protocol = '4'
            }
                
        },
        sendData(){
            this.$refs["traceRouteForm"].validate(valid => {
                if(valid)
                {
                    this.setData()
                }

            })
        }
    },
}
</script>
<style lang="scss" scoped>
.fhv-centent {
  .panel-heading {
    color: #333;
    background-color: #f5f5f5;
    border-color: #ddd;
    padding: 10px 15px;
    border-bottom: 1px solid transparent;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .textb {
    padding: 15px;
  }
}
</style>





